import axios from 'axios';
import get from 'lodash/get';
import set from 'lodash/set';

const sureAxios = axios.create({
  baseURL: process.env.REACT_APP_SURE_API_URL,
  headers: {
    'X-Space': process.env.REACT_APP_SPACE || 'farmers',
  },
});

sureAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (get(error, 'response.headers')) {
      set(
        error,
        'response.data.error._hrq',
        error.response.headers['x-request-id']
      );
    }
    return Promise.reject(error);
  }
);

export default sureAxios;
